import { capitalizeFirstLetter } from 'src/utils/string';

const matchesSearch = (text, query) => {
  if (!query || !text) return !query;
  const normalizedText = String(text);
  const normalizedQuery = String(query);

  return normalizedText
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .includes(
      normalizedQuery
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    );
};

const createLookupModel = (label, value, requestChange, errors = null) => ({
  label: capitalizeFirstLetter(label || ''),
  value,
  requestChange,
  ...(errors && { errors }),
});

const LookupField = ({
  Component,
  multi,
  clearable,
  model,
  data,
  podeEditar,
  disabled = false,
}) => (
  <div>
    <Component
      multi={multi}
      clearable={clearable}
      disabled={disabled}
      model={model}
      {...(data && { data })}
      {...(podeEditar !== undefined && { podeEditar })}
    />
  </div>
);

export { matchesSearch, createLookupModel, LookupField };
